import axios from "axios";

class BaseAPI {
    static API_KEY = 'zajdbjhbshdbckmewiyuityfnncjcmcskllkmsdjkbhdvbwgv';
    static baseUrl = 'https://api.impactrun.com/web/v1/';

    static async getRequest(url) {
        return await axios.get(this.baseUrl + url, {
            headers: {
                Authorization: this.API_KEY
            }
        });
    }   
}

export default BaseAPI;